import connect from 'utils/store/connect';

import {
  handleDeviceSelected,
  handleIsMobileSelection,
  updateContentContextStates,
  updateHiddenExperiments,
  handleComponentSelection,
  handleComponentDeselection,
  handleComponentHoverEnter,
  handleComponentHoverLeave,
  setContentLinkStatus,
  setMWPIframeRef
} from './actions';
import {
  allExperimentVariantsSelector,
  componentSelectedSelector,
  contentContextStatesSelector,
  contentLinkDisabledSelector,
  deviceSelector,
  hiddenExperimentsSelector,
  mwpIFrameSelector,
  previewContentSelector,
  previewMetadataSelector
} from './selector';
import PreviewPane from './components/PreviewPane';

/**
 * Return object mapping state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
export const mapStateToProps = state => ({
  allExperimentVariants: allExperimentVariantsSelector(state),
  componentSelected: componentSelectedSelector(state),
  contentContextStates: contentContextStatesSelector(state),
  contentLinkDisabled: contentLinkDisabledSelector(state),
  device: deviceSelector(state),
  hiddenExperiments: hiddenExperimentsSelector(state),
  mwpIFrameRef: mwpIFrameSelector(state),
  previewContent: previewContentSelector(state),
  previewMetadata: previewMetadataSelector(state)
});

/**
 * Returns object mapping dispatches to props
 * @returns {object}
 */
export const mapDispatchToProps = {
  deviceSelected: handleDeviceSelected,
  handleIsMobileSelection,
  updateContentContextStates,
  updateHiddenExperiments,
  handleComponentSelection,
  handleComponentDeselection,
  handleComponentHoverEnter,
  handleComponentHoverLeave,
  setContentLinkStatus,
  setMWPIframeRef
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewPane);
